import constants from "../../../core/constants";

class Controller {
  constructor($mdDialog, booking, Ride, RidesTransforms, Route) {
    "ngInject";

    this.$mdDialog = $mdDialog;
    this.booking = booking;
    this.booking.ride.name = this.booking.ride.route.name;
    this.selectedRide = this.booking.ride._id;

    Ride.getAll({
      route: booking.ride.route._id,
      status: ["started", "scheduled", "stopped"],
      sort: "date",
      limit: 100,
    }).$promise.then((response) => {
      this.availableRides = RidesTransforms.justify(response.hits);
    });

    Route.get(booking.ride.route._id).$promise.then((response) => {
      this.stations = response.stations;
    });
  }

  close() {
    this.$mdDialog.cancel();
  }

  confirm() {
    if (this.pickup && this.dropoff) {
      const user = this.booking.user._id;
      const pickUp = this.pickup;
      const dropOff = this.dropoff;
      const ride = this.booking.ride._id;
      const price = this.booking.priceNum * constants.currencyBy;
      const payment = { method: "cash" };
      const seatCount = this.seats;
      const promotion = this.promotion;

      this.$mdDialog.hide({
        user,
        ride,
        payment,
        price,
        pick_up: pickUp,
        drop_off: dropOff,
        promotion_code: promotion,
        seat_count: seatCount,
      });
    }
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/components/actionListTable/rebookDialog/rebookDialog.controller.js